var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"font-weight-bold",attrs:{"x-large":"","text":"","color":"teal","block":""},on:{"click":function($event){return _vm.addPedido()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._v("ADICIONAR PEDIDO")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }